import {
  acceptablePercent,
  optimalPercent,
  weakPercent,
  withoutConnectionPercent,
} from './Util'

export const STATUSES = [
  {
    name: 'optimal',
    prefix: `${optimalPercent}%+`,
    color: '#198D10',
  },
  {
    name: 'acceptable',
    prefix: `${acceptablePercent}%+`,
    color: '#A1BC12',
  },
  {
    name: 'weak',
    prefix: `${weakPercent}%+`,
    color: '#EE3B3B',
  },
  {
    name: 'veryWeak',
    prefix: `${weakPercent}%-`,
    color: '#B00C0C',
  },
  {
    name: 'withoutConnection',
    prefix: ``,
    color: '#5F6368',
  },
]
